import { createEnumType } from 'acscp/api/models/customTypes/enumUtils';

export enum LengthUnit {
    Centimetre = 'Centimetre',
    Inch = 'Inch',
}

export const LengthUnitDynamicType =  createEnumType('LengthUnit', LengthUnit);
